export default "__VITE_ASSET__4LMty0uz__"